import {useMemo} from "react";
import {stringAvatarForUser} from "../../../../appfw/users/UserUtil";
import {Avatar} from "@mui/material";
import {useUser} from "../../../../appfw/users/User.tsx";

interface AvatarWidgetProps {
    id: string;
    size?: number;
}

export default function AvatarWidget(props: AvatarWidgetProps) {

    const userHook = useUser(props.id)

    return useMemo(() => {

        let user = userHook.data
        if (user == undefined) {
            return <Avatar/>
        }

        const sx = props.size ? {height: `${props.size}px`, width: `${props.size}px`} : null
        if (user.avatarUrl) {
            return <Avatar alt={user?.name} src={user.avatarUrl} sx={sx}/>
        } else if (user.name) {
            return <Avatar alt={user?.name} {...stringAvatarForUser(user)} sx={sx}/>
        }

    }, [userHook])
}
